import { GiSpy } from 'react-icons/gi'

interface LandingFooterProps {
  onNavClick: (id: string) => void
}

export function LandingFooter({ onNavClick }: LandingFooterProps) {
  const currentYear = new Date().getFullYear()

  return (
    <footer className="landing-footer">
      <div className="landing-footer-inner">
        <div className="landing-footer-top">
          <div>
            <div className="landing-footer-brand">
              <GiSpy style={{ color: 'var(--accent)', fontSize: '1.5rem' }} />
              <span>StatScout</span>
            </div>
            <p className="landing-footer-tagline">
              Bet smarter, not harder. Data-driven football analytics for informed betting decisions.
            </p>
          </div>

          <div>
            <h4 className="landing-footer-column-title">Product</h4>
            <ul className="landing-footer-links">
              <li>
                <span className="landing-footer-link" onClick={() => onNavClick('features')}>
                  Features
                </span>
              </li>
              <li>
                <span className="landing-footer-link" onClick={() => onNavClick('pricing')}>
                  Pricing
                </span>
              </li>
              <li>
                <span className="landing-footer-link" onClick={() => onNavClick('faq')}>
                  FAQ
                </span>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="landing-footer-column-title">Legal</h4>
            <ul className="landing-footer-links">
              <li>
                <span className="landing-footer-link">Privacy Policy</span>
              </li>
              <li>
                <span className="landing-footer-link">Terms of Service</span>
              </li>
              <li>
                <span className="landing-footer-link">Cookie Policy</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="landing-footer-bottom">
          <span className="landing-footer-copyright">
            © {currentYear} StatScout. All rights reserved.
          </span>
          <span className="landing-footer-domain">statscout.co</span>
        </div>
      </div>
    </footer>
  )
}
